class DataSource{
    static USER = 0;
    static PROFILE = 1;
    static SCAN = 2;
}
export default DataSource;